const oidcProdConfig = {
  client_id: 'elvisconnect_xxpa_prod',
  redirect_uri: window.location.origin + '/authentication/callback',
  silent_redirect_uri: window.location.origin + '/authentication/silent-callback',
  scope: 'openid profile email',
  authority: 'https://sso.id.eurofins.com',
  service_worker_only: true,
  grant_type: 'authorization code',
  post_logout_redirect_uri: 'query',
  userinfo_endpoint: 'https://sso.id.eurofins.com/idp/userinfo.openid',
  token_endpoint: 'https://sso.id.eurofins.com/as/token.oauth2',
  authorization_endpoint: "https://sso.id.eurofins.com/as/authorization.oauth2",
  revocation_endpoint: "https://sso.id.eurofins.com/as/revoke_token.oauth2"
};

export default oidcProdConfig;